import { get } from "@insite/client-framework/Services/ApiService";

export interface FaqModel {
   id: string;
    question: string;
    answer: string;
}

export interface FaqCollectionModel {
    uri: string;
    brandId: string;
    faqs: FaqModel[];
    properties: Record<string, unknown>;
}


export interface GetBrandFaqsApiParameter {
    brandId: string;
}

export function getBrandFaqs(apiParameter: GetBrandFaqsApiParameter) {
    return get<FaqCollectionModel>(`/api/v2/faq/brand/${apiParameter.brandId}`);
}


 